import {Injectable} from '@angular/core';
import {environment} from "../../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import Bugsnag from "@bugsnag/js";
import {BehaviorSubject, map, Observable, Subscription} from "rxjs";
import {SurveyViewerService} from "../survey-viewer/services/survey-viewer.service";

@Injectable({
  providedIn: 'root'
})
export class EditResponseService {

  BASE_URL = environment.apiUrl

  public getRawResult$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public rawResultFromDatabase: any = {};

  constructor(
    private _httpClient: HttpClient,
  ) {
  }

  public getRawResultFromDatabase() {
    return this.rawResultFromDatabase;
  }

  getRawResult(surveyId: number): Subscription {

    this.getRawResult$.next(true);

    const endpoint = `${this.BASE_URL}/appCommunity/actions`
    const action = 'getRawResult'
    const body = {
      action,
      params: {
        surveyId,
      },
    }

    return this._httpClient.post(endpoint, body)
      .pipe()
      .subscribe({
        next: (response: any) => {
          const {rawResult} = response.data.datas;
          console.log('[RawResult from database]', rawResult);
          this.rawResultFromDatabase = rawResult;
          return true;
        },
        error: err => {
          Bugsnag.notify(err, (event) => {
            event.addMetadata('Home Service', {
              method: this.getRawResult.name,
              body,
              endpoint
            })
          })
          return false;
        }
      })

  }


}
